import React from 'react';
import Layout from './Layout';
// import {useParams} from 'react-router-dom';
// import {useQuery} from 'react-query';
// import {fetchAuthenticationDetails} from '../../../requests/queries/easyAuth';

function BehavioralScore() {
  // const {slug} = useParams();

  // const {data, isLoading} = useQuery(['auth-address', slug], () =>
  //   fetchAuthenticationDetails({authenticationId: slug, type: 'summary'}),
  // );

  const items = [
    {
      title: 'Interaction matching',
      description: 'User interactions match/don’t the usual profile',
      score: '40%',
    },
    {
      title: 'Device Risk',
      description: 'Device associated or not associated with user',
      score: '10%',
    },
    {
      title: 'IP/Location Risk',
      description: 'Location associated or not associated with user',
      score: '80%',
    },
    {
      title: 'Other flags',
      description: 'Anomalies found',
      score: '20%',
    },
  ];

  return (
    <Layout>
      <div className="bg-white min-h-[660px]">
        <div className="flex justify-between w-full items-center">
          <p className="font-medium text-grey">Behavioral Score</p>
          <div className="flex uppercase pt-[5px] pb-[3px] text-[#396C31] px-2 text-xs font-medium rounded-full bg-[#F0F6EF] w-fit items-start gap-[2px]">
            95% Score
          </div>
        </div>

        <div className="mt-6">
          {items.map((item, index) => (
            <div
              key={index}
              className={`flex items-center justify-between py-4 ${
                index === 0
                  ? 'border-t border-b border-grey60'
                  : 'border-b border-grey60'
              }`}
            >
              <div className="flex flex-col gap-1">
                <p className="text-grey uppercase font-medium text-small">
                  {item.title}
                </p>
                <p className="text-[#4E4E4E] text-xs">{item.description}</p>
              </div>
              <p className="text-sm">{item.score}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}

export default BehavioralScore;
